import Vue from "vue";

export default {
	state: {
		openPages: ["home", "redirect"],
		userPermissions: {},
		permissionList: [],
		clientModel: {},
		assumeIdentityPermissions: {}
	},

	mutations: {
		setPermissionsOnState(state, permissions) {
			state.userPermissions = mapPermissions(permissions);
		},
		setPermissionListOnState(state, permissions) {
			state.permissionList = mapPermissionList(permissions);
		},
		setClientModelOnState(state, clientModel) {
			state.clientModel = clientModel;
		},
		setAssumeIdentityPermissionsOnState(state, permissions) {
			state.assumeIdentityPermissions = mapPermissions(permissions);
		}
	},

	actions: {
		getUserConfigurations({ commit }, data) {
			if (data.baseRoute == "home") return;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("permission/" + data.baseRoute + "/" + data.idUser)
					.then((response) => {
						commit("setPermissionsOnState", response.data.data.permissions);
						resolve(response);
					})
					.catch((error) => {
						console.error(error);
						reject(error);
					});
			});
		},
		getPermissionList({ commit }) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("permission")
					.then((response) => {
						commit("setPermissionListOnState", response.data.data.permissions);
						commit("setClientModelOnState", response.data.data.clientModel);
						this.state.loading = false;
						resolve();
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getUserPermissionList(_, idUser) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("permission/user/" + idUser)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data.permissions);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getAssumeIdentityPermissions({ commit }, idUser) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("permission/supplierAssumeIdentity/" + idUser)
					.then((response) => {
						commit("setAssumeIdentityPermissionsOnState", response.data.data.permissions);
						resolve(response);
					})
					.catch((error) => {
						console.error(error);
						reject(error);
					});
			});
		}
	},

	getters: {
		userPermissions: (state) => {
			return state.userPermissions;
		},
		permissionList: ({ permissionList }) => {
			return permissionList;
		},
		clientModel: ({ clientModel }) => {
			return clientModel;
		},
		assumeIdentityPermissions: ({ assumeIdentityPermissions }) => {
			return assumeIdentityPermissions;
		}
	}
};

function mapPermissions(permissions) {
	let mappedPermissions = {
		read: false,
		create: false,
		update: false,
		delete: false
	};
	permissions.forEach((permission) => (mappedPermissions[permission] = true));
	return mappedPermissions;
}

function mapPermissionList(permissions) {
	let mappedPermissions = [];
	permissions.forEach((permission) => {
		mappedPermissions.push({
			idPermission: permission.idPermission,
			name: permission.name,
			description: permission.description,
			baseRoute: Vue.prototype.$permissionsName[permission.baseRoute],
			idPermissionType: permission.idPermissionType,
			selected: false,
			children: permission.children.map((child) => {
				return {
					idPermission: child.idPermission,
					idPermissionType: child.idPermissionType,
					baseRoute: child.baseRoute,
					name: Vue.prototype.$permissions[child.name]
				};
			})
		});
	});
	return mappedPermissions;
}
